export const NO_AUTH = "x-no-auth";
export const CORRELATION_BAGGAGE = "X-Correlation-Baggage";
export const PAGING_PAGE_NUMBER = "x-paging-page-number";
export const PAGING_TOTAL_PAGES = "x-paging-total-pages";
export const PAGING_TOTAL_COUNT = "x-paging-total-count";
export const MIN_PAGE_ITEMS = 25;
